let state = {
    PaginaInicial_Micrositio: null
  };
  
  let getters = {
    Get_PaginaInicial_Micrositio: state => {
        return state.PaginaInicial_Micrositio;
    }
  }
  
  let mutations = {
    M_PaginaInicial_Micrositio(state, data) {
      state.PaginaInicial_Micrositio = data;
  }
  };
  
  let actions = {
    A_PaginaInicial_Micrositio: ({ commit }, data) => {
      commit('M_PaginaInicial_Micrositio', data);
    } 
  };
  
  const Micrositio = {
    State: state,
    Getters: getters,
    Mutations: mutations,
    Actions: actions
  };
  
  export default Micrositio;
  


// WEBPACK FOOTER //
// ./src/store/Micrositios.js